"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeDefaults = void 0;
exports.typeDefaults = {
    array: () => [],
    boolean: () => false,
    // datetime: () => new Date(),
    integer: () => 0,
    null: () => null,
    number: () => 0,
    object: () => ({}),
    string: () => "",
    any: () => null,
};
//# sourceMappingURL=consts.js.map